module.exports = __webpack_public_path__ + "static/bg1-9a2d46c4f53552a481ce4d780c86288a.jpg";